module.exports = __webpack_public_path__ + "img/pop_icon_cutover.91e5b574.svg";